<hr class="wuc-line" [class.wuc-line--top]="noMarginTop" [class.wuc-line--bottom]="noMarginBottom" />
